// extracted by mini-css-extract-plugin
export default {"productDescription":"Jaa-z","featuredDescription":"Kaa-z","description":"Laa-z","more":"Maa-z","descriptionSku":"Naa-z"};